export enum TCommonFieldSize {
  Small = 2,
  Quarter = 3,
  Medium = 4,
  Half = 6,
  Large = 8,
  ThreeQuarters = 9,
  Full = 12,
}
